module.exports = __webpack_public_path__ + "img/xlayer.5d048ef1.png";